<template>
  <main-page :user="user" color="green">
    <template v-slot:title> CANVAS FEEDBACK </template>
    <div class="container">
      <div class="row content">
        <div
          class="col-8 zone-padding text-left d-flex flex-column justify-content-center h-100"
        >
          <h1 class="mb-2 si-font si-text-orange">Team</h1>
          <config-select
            class="vs-big mb-4"
            :options="teams"
            label="name"
            v-model="team"
            :disabled="user.role != 'TEACHER'"
          />
          <div class="text-left" v-if="team">
            <template v-for="assignment in assignments">
              <div
                v-if="assignment.feedbacks.length > 0"
                :key="`header-${assignment.id}`"
                class="table-head border"
              >
                <h2 class="my-0 si-font">{{ assignment.name }}</h2>
              </div>
              <table
                v-if="assignment.feedbacks.length > 0"
                :key="`table-${assignment.id}`"
                class="table table-striped border text-md mb-5"
              >
                <thead>
                  <tr>
                    <th v-if="team.all">Team</th>
                    <th>Reviewer</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Students -->
                  <tr v-for="(feedback, i) in assignment.feedbacks" :key="i">
                    <td v-if="team.all">{{ feedback.team_name }}</td>
                    <td
                      v-if="feedback.user"
                      class="v-mid"
                      style="min-width: 120px"
                    >
                      <div style="line-height: 1.2">
                        {{ name(feedback.user.name) }}
                      </div>
                      <div class="si-font text-muted" style="line-height: 1">
                        {{ feedback.user.role }}
                      </div>
                    </td>
                    <td class="v-mid">{{ feedback.response }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="col-6 text-right">
        <a class="btn btn-si-secondary" href="#/canvas">Back</a>
      </div>
    </template>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import ConfigSelect from "@/components/ConfigSelect";

import SectionService from "@/services/SectionService";
import CanvasService from "@/services/CanvasService";

import Notie from "@/services/NotieService";
import BB from "bluebird";
import fs from "@/services/FormatService";
import _ from "lodash";

export default {
  name: "CanvasFeedback",

  props: ["user"],

  components: { MainPage, ConfigSelect },

  data() {
    return {
      context: null,
      teams: null,
      team: null,

      assignments: null,
    };
  },

  created() {
    this.loadData();
  },

  watch: {
    team() {
      if (this.team) {
        if (this.team.all) {
          _.each(this.assignments, (a) => {
            a.feedbacks = _.filter(this.feedbacks, {
              assignment_id: a.id,
            });
          });
        } else {
          _.each(this.assignments, (a) => {
            a.feedbacks = _.filter(this.feedbacks, {
              team_id: this.team.id,
              assignment_id: a.id,
            });
          });
        }
      }
    },
  },

  methods: {
    loadData() {
      BB.props({
        context: SectionService.getContextPrefilled(),
        feedbacks: CanvasService.getContextCanvasFeedbacks(),
      })
        .then((r) => {
          console.log(r.feedbacks);
          this.context = r.context.data;
          this.feedbacks = r.feedbacks.data;
          this.teams = this.context.teams;
          if (this.teams.length > 0) {
            this.team = this.teams[0];
          }
          if (this.user.role != "TEACHER") {
            this.selectOwnTeam(this.teams);
          } else {
            //add all teams option
            this.team = { id: 0, name: "All Teams", all: true };
            this.teams.push(this.team);

            _.each(this.feedbacks, (f) => {
              f.team_name = _.filter(this.teams, { id: f.team_id })[0].name;
            });
          }

          this.assignments = this.context.canvases;
          if (this.team) {
            if (this.team.all) {
              _.each(this.assignments, (a) => {
                a.feedbacks = _.filter(this.feedbacks, {
                  assignment_id: a.id,
                });
              });
            } else {
              _.each(this.assignments, (a) => {
                a.feedbacks = _.filter(this.feedbacks, {
                  team_id: this.team.id,
                  assignment_id: a.id,
                });
              });
            }
            console.log("ASSIGNMENTS", this.assignments);
          }
        })
        .catch((e) => {
          Notie.error("Failed to load feedback", e);
          console.log(e);
        });
    },

    selectOwnTeam(teams) {
      for (var team of teams) {
        for (var userID of team.user_ids) {
          if (userID == this.user.id) {
            this.team = team;
            return;
          }
        }
      }
    },

    name(n) {
      return fs.displayName(n);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 1rem;
}
.zone-padding {
  padding: 3rem;
}
.table-head {
  background-color: #f0f0f0 !important;
  padding: 0.75rem;
  margin-bottom: 1rem;
}
.v-mid {
  vertical-align: middle;
}
</style>